module.exports = __webpack_public_path__ + "img/caracteristicas-video.430ede18.png";